module.exports = __webpack_public_path__ + "img/indoor.9c7a699a.png";